import "scripts/templates/cart.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.cart");
